/* ==========================================================================
   Elevate Floors — Seção 08: Reviews

   Mesmo trilho infinito da Seção 05 (ef-rail.js), mas o avanço aqui NÃO é
   contínuo: é um cartão por vez, a cada N segundos.
   ========================================================================== */
(function () {
  'use strict';

  function initSection(section) {
    if (section._efRevBound || !window.EFRail) return;
    section._efRevBound = true;

    var rail = section.querySelector('[data-rail]');
    if (!rail) return;

    var cs = getComputedStyle(section);
    var INTERVAL = (parseFloat(cs.getPropertyValue('--ef-rev-interval')) || 0) * 1000;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) INTERVAL = 0;

    var track = window.EFRail.attach(rail);
    var timer = null;

    /* um passo = a largura de um cartão + o gap.
       Medir o cartão em vez de cravar um número importa: a largura muda entre
       desktop (380px) e mobile (262px), e um valor fixo desalinharia num dos dois. */
    function step(dir) {
      var card = rail.firstElementChild;
      if (!card) return;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 18;
      var w = card.getBoundingClientRect().width + gap;
      rail.scrollTo({ left: rail.scrollLeft + dir * w, behavior: 'smooth' });
      // o reposicionamento do loop só pode acontecer DEPOIS que a rolagem
      // suave terminar: no meio dela o navegador cancela a animação e o
      // cartão dá um tranco
      setTimeout(track.loop, 700);
    }

    function start() {
      if (timer || INTERVAL <= 0) return;
      timer = setInterval(function () {
        if (track.isIdle()) step(1);
      }, INTERVAL);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    section.querySelectorAll('.ef-reviews__arrow').forEach(function (b) {
      b.addEventListener('click', function () { step(parseInt(b.dataset.dir, 10)); });
    });

    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });

    requestAnimationFrame(function () { track.center(); start(); });

    // fontes e imagens podem mudar a largura depois do primeiro frame
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        track.center();
        if (track.isCentered()) ro.disconnect();
      });
      ro.observe(rail);
    } else {
      setTimeout(track.center, 400);
    }
  }

  function init() {
    document.querySelectorAll('[data-reviews]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
